// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressLocationsStyles } from "@ces/App/Widgets/Header/AddressLocations";
import Location from "@ces/XDL/Icons/Location";
import { GhostSecondaryButtonStyles } from "@ces/XDL/PreStyle/button";
import { color, xScreen } from "@ces/XDL/Utilities";
import { ButtonIcon } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

addressLocationsStyles.wrapper = {
    css: css`
        display: flex;
        margin-left: 12px;
        ${xScreen("lte", "md")} {
            margin-left: 0;
        }
    `,
};

addressLocationsStyles.changeLink = {
    variant: "tertiary",
    sizeVariant: "small",
    css: css`
        ${IconWrapper} {
            width: 9px;
            height: 11px;
            opacity: 0.66;
            top: 0;
            color: ${color("secondary")};
        }

        &:not(:disabled):hover ${ButtonIcon} {
            color: ${color("secondary")};
            opacity: 0.33;
        }

        padding: 0px 12px;
        ${GhostSecondaryButtonStyles}
        min-height: 22px;
        width: 94px;
    `,
    icon: {
        src: Location,
        position: "left",
    },
};
